import React from 'react'
import { useHistory } from 'react-router-dom'
import { ControlOutlined, LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { Dropdown, Menu} from 'antd';
import { MenuInfo } from 'rc-menu/lib/interface'

import OIDC from '../../../..//pages/oidc'
import Logout from '../../../../pages/oidc/logout'
import { getEnv } from 'App/util/env'

type TUserMenuEnv = {
  EDIT_USER_PROFILE_URL: string
}
const reactUserMenuEnv = process.env.REACT_APP_EDIT_USER_PROFILE_URL
const userMenuEnv = getEnv<TUserMenuEnv>({
  EDIT_USER_PROFILE_URL:
    reactUserMenuEnv !== undefined
      ? reactUserMenuEnv
      : 'http://home.dev.cloud.accallio.com/profile/',
})

const ProfileMenu = () => {
  const history = useHistory()

  const handleLogout = (info: MenuInfo) => {
    history.push(`${OIDC.routeProps.path}${Logout.routeProps.path}`)
  }

  const handleProfileClick = () => {
    if (userMenuEnv.EDIT_USER_PROFILE_URL.startsWith('http')) {
      window.open(userMenuEnv.EDIT_USER_PROFILE_URL, '_blank')
    } else {
      history.push(userMenuEnv.EDIT_USER_PROFILE_URL)
    }
  }

  const menu = (
    <Menu selectable={false}>
      <Menu.Item onClick={handleProfileClick}>
        <ControlOutlined />
        Edit Profile
      </Menu.Item>
      <Menu.Item onClick={handleLogout}>
        <LogoutOutlined />
        Logout
      </Menu.Item>
    </Menu>
  )

  return (
    <Dropdown className="dropdown-btn" overlay={menu} placement="bottomRight" trigger={['click']}>
      <UserOutlined />
    </Dropdown>
  );
}

export default ProfileMenu
